import { selectFromRouteDto } from '../../models';

export default selectFromRouteDto()
  .constraints(constraint => constraint
    .startLocations(startLocation => startLocation.address.active.bestMatch.locationStatusId))
  .toString();
